<script>
import newBidInput from "../components/form components/newBidInput";

export default {
  name: "autobid-entry",
  components: {
    newBidInput,
  },
  data: function() {
    return {
      bidLimit: this.activeBid && this.activeBid.bidLimit ? this.activeBid.bidLimit : null,
      autoBidEnabled: this.activeBid ? this.activeBid.autoBid : false,
    };
  },
  methods: {
    onModalClose: function() {
      this.$store.commit("setAutoBidModalVisible", false);
    },
    async updateBidLimit() {
      var formData = new FormData();
      formData.append("bidId", this.activeBid.offerId);
      formData.append("auctionId", this.activeAuction.id);
      formData.append("limit", this.bidLimit);
      formData.append("autobid", this.autoBidEnabled);
      var result = await this.$store.dispatch("postRequest", { controller: "auction", method: "setBidLimit", parameters: formData });
      if (result) {
        this.$emit("bidLimitUpdated");
      }
      this.onModalClose();
    },
  },
  computed: {
    currency: function() {
      return this.$store.state.activeAuction.currency;
    },
    activeBid: function() {
      return this.$store.state.activeBid || null;
    },
    activeAuction: function() {
      return this.$store.state.activeAuction || null;
    },
    minIncrement: function() {
      return this.$store.state.activeAuction.minIncrement;
    },
    bidFormatted: function() {
      return this.bidLimit ? `${this.bidLimit.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")} ${this.currency}` : "";
    },
    currentBidFormatted: function() {
      return this.activeBid ? `${this.currency} ${this.activeBid.currentRate.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}` : "";
    },
    minDecrimentDisplay: function() {
      var self = this;
      return `${self.minIncrement} ${self.currency}`;
    },
    showBidEntry: function() {
      return this.$store.state.autobidModalVisible;
    },
  },
  watch: {
    activeBid: {
      handler: function(val) {
        if (val) {
          var self = this;
          self.bidLimit = val.bidLimit || null;
          self.autoBidEnabled = val.autoBid || false;
        }
      },
      deep: true,
    },
  },
};
</script>
<template>
  <div v-if="activeBid">
    <b-modal id="bid-entry-modal" :title="`Autobid Details (${activeBid.vesselName})`" v-model="showBidEntry" v-on:hidden="onModalClose">
      <div class="row">
        <div class="col-lg-12">
          <i>Current Bid Amount: {{ currentBidFormatted }}</i>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <span class="title-text">Autobid Limit</span><br />
          <new-bid-input v-model="bidLimit" :inputValue="bidLimit == null ? null : parseInt(bidLimit)" :formatAsCurrency="true" :max="this.activeBid.currentRate" :currentBid="activeBid.currentRate"></new-bid-input>

          <b-form-checkbox v-model="autoBidEnabled" :value="true" :unchecked-value="false">
            <span class="title-text">Enable 'Autobid'</span>
          </b-form-checkbox>
        </div>
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <div class="row" style="width:100%">
          <div class="col-6" style="padding-left:0px;padding-right:5px;">
            <b-button class="button-full" size="sm" variant="danger" v-on:click="cancel()">
              Cancel
            </b-button>
          </div>
          <div class="col-6" style="padding-right:0px;padding-left:5px;">
            <b-button class="button-full" size="sm" variant="success" v-on:click="updateBidLimit()">
              Save Changes
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<style scoped>
.context-text {
  font-size: 18px;
}
.title-text {
  font-size: 12px;
}
.bid-alert {
  color: red;
  font-size: 12px;
}
.button-full {
  width: 100%;
}
</style>
